export default __webpack_public_path__ + "static/media/success.f99cc53d.gif";